exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*{\r\n  margin: 50;\r\n  padding: 50;\r\n}\r\n.logo {\r\n  width: 150px;\r\n}\r\n.dropdown-toggle{\r\n  cursor: pointer;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Michel/Documents/edenz_local/cellwatchWebApp/src/app/cellwatch-navbar/cellwatch-navbar.component.css
// module id = ../../../../../src/app/cellwatch-navbar/cellwatch-navbar.component.css
// module chunks = main